import { render, staticRenderFns } from "./ProductClueSearch.vue?vue&type=template&id=1f6ad5b3&scoped=true&"
import script from "./ProductClueSearch.vue?vue&type=script&lang=js&"
export * from "./ProductClueSearch.vue?vue&type=script&lang=js&"
import style0 from "./ProductClueSearch.vue?vue&type=style&index=0&id=1f6ad5b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ad5b3",
  null
  
)

export default component.exports